// public int fStyleId { get; set; }
// public string fTemplatename { get; set; }
// public Nullable<int> fClientId { get; set; }
// public string fLanguages { get; set; }
// public Nullable<int> fFrameSplit { get; set; }
// public Nullable<int> fMinLengthPerLine { get; set; }
// public Nullable<int> fMaxLengthPerLine { get; set; }
// public Nullable<int> fMinLengthPerSecond { get; set; }
// public Nullable<int> fMaxLengthPerSecond { get; set; }
// public Nullable<int> fMaxDurationSecond { get; set; }
// public Nullable<int> fMaxDurationFram { get; set; }
// public Nullable<int> fMinDurationSecond { get; set; }
// public Nullable<int> fMinDurationFram { get; set; }
// public Nullable<int> fMaxCountOfLines { get; set; }
// public Nullable<int> fFontId { get; set; }
// public Nullable<int> fFontSize { get; set; }
// public Nullable<int> fLineSpacing { get; set; }
// public Nullable<int> fCharaterSpacing { get; set; }
// public Nullable<int> fAllowPositioningType { get; set; }
// public Nullable<int> fCenterJustificationType { get; set; }
// public Nullable<int> fSaveAreaXLeft { get; set; }
// public Nullable<int> fSaveAreaXRight { get; set; }
// public Nullable<int> fSaveAreaYTop { get; set; }
// public Nullable<int> fSaveAreaYBottom { get; set; }
// public int fIsRemoveContinuousWhitespace { get; set; }
// public int fQC_MissingTimecodeError { get; set; }
// public int fQC_TimecodeOverlapError { get; set; }
// public int fQC_DurationError_min { get; set; }
// public int fQC_DurationError_max { get; set; }
// public int fQC_EmptySubError { get; set; }
// public int fQC_ChartacterLimtError { get; set; }
// public int fQC_ReadSpeedError { get; set; }
// public int fQC_MaxLineError { get; set; }
// public int fQC_PositionCheckError { get; set; }
// public int fQC_NetflixWhitelistCharactersCheckError { get; set; }
// public int fQC_Half_white_ChartaterError { get; set; }
// public int fQC_SimplifiedError { get; set; }


import React, {  useEffect, useState} from 'react';
import { useHistory ,useLocation} from 'react-router-dom';
import { Button } from 'semantic-ui-react'
import ApiUtils from "../../helper/ApiUtils";
import Spinner from "../common/Spinner";
import Client_Add from "./Client_Add";
import Client_list from "./Client_list";

const ClientPage = () => {
    const history = useHistory();
    const location = useLocation();

    const [loading,setloading] = useState(false);
//網址判斷
    useEffect(() => {

        // post_Style_GetClientList
        getClient();
    }, [location]);



    const getClient = async ()=>{

        /**
         * 廠商
         * */
         const getClient_jsonData = await ApiUtils.post_sql(`${ApiUtils.post_Style_GetClientList}`);
        // [{"fId":1,"fName":"Medialink Group Ltd.","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1},{"fId":2,"fName":"酷遊天國際旅行社股份有限公司","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1}]
        setclientList(getClient_jsonData);

        /**
         * 語系
         * */
        const　LanguageList_jsonData = await ApiUtils.post_sql(`${ApiUtils.post_Style_GetLanguageList}`);
        //語系列表
        setLanguageList(LanguageList_jsonData);
        // {
        //     "fId": 1,
        //     "fName": "繁體中文",
        //     "fCode": "zhtw",
        //     "fCountry": null
        // },


        const getlist_jsonData = await ApiUtils.post_sql(`${ApiUtils.post_Style_GetStyleList}`);
        // [{"fId":1,"fName":"Medialink Group Ltd.","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1},{"fId":2,"fName":"酷遊天國際旅行社股份有限公司","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1}]
        setList(getlist_jsonData);
        settotal(getlist_jsonData.length);
    }

    const [List,setList] = useState([]);
    const [total,settotal] = useState(0);

    //廠商
    const [clientList,setclientList] = useState(null);
    const [LanguageList,setLanguageList] = useState(null); //語系選項

    const [showAddForm,setshowAddForm] = useState(false);
    const [showEditForm,setshowEditForm] = useState(false);

    const [editData,seteditData] = useState(null);

    return <div className=' pb-2 position-relative p-3' >

        {(loading===true)?<Spinner/>:<div >
            <Button.Group>
                <Button color={showAddForm===true?'grey':'green'} onClick={()=>{
                    setshowAddForm(!showAddForm);
                }}>{showAddForm===true?'Close Add Form':'Add'}</Button>
            </Button.Group>


            {(clientList !== null && LanguageList !== null)?<Client_list
                List={clientList}
                total={total}
                clientList={clientList}
                LanguageList={LanguageList}

                CallToUpdate={ (fStyleId)=>{

                    let editArray = clientList.filter(data=>data['fId']===fStyleId);
                    const editData = editArray[0];
                    seteditData(editData);
                    setshowEditForm(false);


                    setTimeout(function() {
                        setshowEditForm(true);
                    }.bind(this), 500)
                }}
            />:null}

            {showAddForm===true?<Client_Add type={'add'} finishUpdate={()=>{
                getClient();
            }}/>:null}

            {showEditForm===true?<Client_Add type={'edit'} editData={editData} finishUpdate={()=>{

            }}/>:null}
        </div>}
    </div>;
};

export default ClientPage;



// WEBPACK FOOTER //
// ./src/components/Client/ClientPage.js